import React from 'react'
import cx from 'classnames'

import Grid from '../../../../components/Grid/Grid'
import { formatPhoneNumber, hasMinWidthOf } from '../../utils'

import { TItem } from '../../types'
import ELocale from '../../../../types/locales'

const ContactAreaItem: React.FC<{ item: TItem; locale: ELocale }> = (props) => {
  const target: string =
    typeof props.item.url === 'string'
      ? props.item.url
      : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- this is needed because i didn't know how to type `item` correctly
        props.item.url[props.locale]!
  const isEmail = target.indexOf('@') > -1 // this is a rough assumption but it works for now
  const href = isEmail ? `mailto:${target}` : `tel:+49-${formatPhoneNumber(target)}`
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // ignore clicks on tablet and above
    if (hasMinWidthOf('ms')) {
      e.preventDefault()
    }
  }
  return (
    <Grid.Col as="li" width={6} sm={3} className="text-center pb-32">
      <a href={href} className={cx({ 'sm:cursor-default': !isEmail })} onClick={handleClick}>
        {props.item.icon}
        <p className="text-14 mt-8 sm:mt-12 md:mt-16 md:text-16">{props.item.label}</p>
        <p className="text-18 md:text-24">{target}</p>
      </a>
    </Grid.Col>
  )
}

export { ContactAreaItem as default }
